import React from "react";
import { useLang } from "../context/LanguageContext";

const CAPPUCCINO_VIDEO = "https://videos.pexels.com/video-files/28712675/12458531_1920_1080_30fps.mp4";
const CAPPUCCINO_POSTER =
  "https://images.pexels.com/videos/28712675/arabic-coffee-aromatic-coffee-authentic-coffee-bar-cafe-28712675.jpeg?auto=compress&cs=tinysrgb&w=1200";

const SPRITZ_VIDEO = "https://videos.pexels.com/video-files/5816529/5816529-hd_1920_1080_25fps.mp4";
const SPRITZ_POSTER =
  "https://images.pexels.com/videos/5816529/alcohol-bar-bbq-cocktail-5816529.jpeg?auto=compress&cs=tinysrgb&w=1200";

const COPY = {
  it: {
    eyebrow: "I nostri riti",
    title_1: "Due gesti,",
    title_2: "una stessa",
    title_3: "ospitalità.",
    cappuccino_title: "Il cappuccino.",
    cappuccino_body:
      "Latte vaporizzato, mano ferma, crema d'espresso che riceve. Ogni mattina disegniamo un piccolo cuore — per dirti che qui sei a casa.",
    spritz_title: "Lo Spritz.",
    spritz_body:
      "Prosecco, bitter, una fetta di arancia e un sorriso. La nostra ora dell'aperitivo è un piccolo viaggio in Italia, ogni sera dalle sei.",
    caption: "Caffè & Cucina Sorriso · München",
  },
  en: {
    eyebrow: "Our rituals",
    title_1: "Two gestures,",
    title_2: "the same",
    title_3: "hospitality.",
    cappuccino_title: "The cappuccino.",
    cappuccino_body:
      "Steamed milk, a steady hand, espresso crema waiting. Every morning we draw a small heart — to tell you that here, you're home.",
    spritz_title: "The Spritz.",
    spritz_body:
      "Prosecco, bitter, an orange slice and a smile. Our aperitivo hour is a small journey to Italy, every evening from six.",
    caption: "Caffè & Cucina Sorriso · Munich",
  },
  de: {
    eyebrow: "Unsere Rituale",
    title_1: "Zwei Gesten,",
    title_2: "eine gleiche",
    title_3: "Gastfreundschaft.",
    cappuccino_title: "Der Cappuccino.",
    cappuccino_body:
      "Aufgeschäumte Milch, eine ruhige Hand, wartende Espresso-Crema. Jeden Morgen zeichnen wir ein kleines Herz — damit Sie wissen, dass Sie hier zu Hause sind.",
    spritz_title: "Der Spritz.",
    spritz_body:
      "Prosecco, Bitter, eine Orangenscheibe und ein Lächeln. Unsere Aperitivo-Stunde ist eine kleine Reise nach Italien, jeden Abend ab sechs.",
    caption: "Caffè & Cucina Sorriso · München",
  },
};

const VideoCard = ({ src, poster, title, body, testid }) => (
  <div className="space-y-6" data-testid={testid}>
    <div className="relative aspect-video overflow-hidden ring-1 ring-[color:var(--gold)]/30 shadow-2xl shadow-black/40">
      <video
        src={src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="w-full h-full object-cover"
        data-testid={`${testid}-video`}
      />
      <div className="pointer-events-none absolute inset-2 border border-[color:var(--gold)]/15"></div>
    </div>
    <div>
      <h3 className="font-serif-display text-3xl lg:text-4xl text-[color:var(--cream)]">
        <span className="font-serif-accent text-[color:var(--gold)]">— </span>
        {title}
      </h3>
      <p className="mt-4 text-base leading-relaxed text-[color:var(--cream)]/80 max-w-md">
        {body}
      </p>
    </div>
  </div>
);

const RitualSection = () => {
  const { lang } = useLang();
  const t = COPY[lang] || COPY.it;

  return (
    <section
      data-testid="ritual-section"
      className="relative wine-dark-bg py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16 lg:mb-20">
          <p className="overline text-[color:var(--gold)] flex items-center">
            <span
              className="inline-block w-10 h-px bg-[color:var(--gold)] mr-3 align-middle"
              style={{ transform: "translateY(-3px)" }}
            ></span>
            {t.eyebrow}
          </p>
          <h2 className="mt-6 font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[color:var(--cream)]">
            {t.title_1}
            <br />
            <span className="font-serif-accent text-[color:var(--gold)] ml-[8%]">
              {t.title_2}
            </span>
            <br />
            <span className="ml-[3%]">{t.title_3}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <VideoCard
            src={CAPPUCCINO_VIDEO}
            poster={CAPPUCCINO_POSTER}
            title={t.cappuccino_title}
            body={t.cappuccino_body}
            testid="ritual-cappuccino"
          />
          <VideoCard
            src={SPRITZ_VIDEO}
            poster={SPRITZ_POSTER}
            title={t.spritz_title}
            body={t.spritz_body}
            testid="ritual-spritz"
          />
        </div>

        <p className="mt-16 overline text-[color:var(--cream)]/40">{t.caption}</p>
      </div>
    </section>
  );
};

export default RitualSection;
